import { all } from 'redux-saga/effects';
import authSaga from './authSaga';
import dashboardSaga from './dashboardSaga';
import quickpaySaga from './quickpaySaga';
import eSignContractModificationSaga from './eSignContractModification';
import applePaySaga from './applePaySaga';

const sagas = function* () {
  yield all([
    authSaga(),
    dashboardSaga(),
    quickpaySaga(),
    eSignContractModificationSaga(),
    applePaySaga(),
  ]);
};

export default sagas;
